var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ride-list__card"},[_c('Header',{attrs:{"status":_vm.ride.status}}),_c('Body',{attrs:{"ride":_vm.ride}}),_c('Footer',{attrs:{"ride":_vm.ride},on:{"rideEvent":_vm.handleRideEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }